// import { BaseInput } from './baseInput';

export class PaymentInput {
  userToken: string
  paySlipImageContact: string
  fullName: string
  address: string
  CompanyTaxId: string
  idNumber: number
  branchCode: string
  email: string
  paymentAmount: string
}
